import React from 'react';
import { TOPOLOGY_LINK_STROKE } from '../TopologyData';

/** Swatches for the thresholds `getLatencyColor` applies against a baseline. */
const ITEMS = [
    { color: TOPOLOGY_LINK_STROKE.success, label: 'At or below baseline' },
    { color: TOPOLOGY_LINK_STROKE.warning, label: 'Up to 30% above baseline' },
    { color: TOPOLOGY_LINK_STROKE.danger, label: 'More than 30% above baseline' },
];

const LatencyBaselineLegend: React.FC = () => (
    <>
        {ITEMS.map((item) => (
            <span key={item.label} className="flex items-center gap-1">
                <span
                    className="inline-block w-3 h-3 rounded-sm"
                    style={{ background: item.color }}
                />
                {item.label}
            </span>
        ))}
    </>
);

export default LatencyBaselineLegend;
